
import store from "../store";
import * as types from "./constants";
import * as utils from "../utils";

export function editFeedComment(postId, comment, mentions=[], captcha=null) {
  const postData = {
    comment,
    captcha,
    mentions: JSON.stringify(mentions)
  };
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/?gid=${window.guest_id}`;
  window.$.ajax({
    data: postData,
    type: 'PUT',
    url
  })
  .success(function(response) {
    store.dispatch({
      type: types.UPDATE_FEED_POST,
      post: response,
      postId
    });
    window.dataLayer.push({
      'event': 'edit comment',
      'post_type': response.post_type
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.handleCaptcha(jqXHR, textStatus, errorThrown, function(captcha) {
      editFeedComment(postId, comment, mentions, captcha);
    });
  });
}

export function editFeedReplyComment(replyId, postId, comment, mentions=[], captcha=null) {
  const postData = {
    comment,
    captcha,
    mentions: JSON.stringify(mentions)
  };
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/${replyId}/?gid=${window.guest_id}`;
  window.$.ajax({
    data: postData,
    type: 'PUT',
    url
  })
  .success(function(response) {
    store.dispatch({
      type: types.UPDATE_FEED_REPLY_COMMENT,
      comment: response.comment,
      mentions,
      postId,
      replyId
    });
    window.dataLayer.push({
      'event': 'edit reply',
      'post_type': response.post_type
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.handleCaptcha(jqXHR, textStatus, errorThrown, function(captcha) {
      editFeedReply(replyId, postId, comment, mentions, captcha);
    });
  });
}

export function likePost(postId) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/like/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'POST',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.LIKE_POST,
    postId
  });
}

export function unlikePost(postId) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/like/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'DELETE',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.UNLIKE_POST,
    postId
  });
}

export function deletePost(postId) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'DELETE',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.REMOVE_POST,
    postId
  });
}

export function postReply(postId, comment, mentions=[], captcha=null) {
  const postData = {
    comment,
    captcha,
    mentions: JSON.stringify(mentions)
  };
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/?gid=${window.guest_id}`;
  window.$.post(url, postData, (response) => {
    store.dispatch({
      type: types.ADD_REPLY,
      reply: response,
      postId
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.handleCaptcha(jqXHR, textStatus, errorThrown, function (captcha) {
      postReply(postId, comment, mentions, captcha);
    });
    if (jqXHR && jqXHR.status !== 412) {
      utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
    }
  });
  window.dataLayer.push({'event': 'reply'});
}

export function getReplies(postId, cursor='') {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/?gid=${window.guest_id}&cursor=${cursor}`;
  window.$.get(url, (response) => {
    store.dispatch({
      type: types.ADD_REPLIES,
      objects: response.objects,
      cursor: response.cursor,
      had_cursor: cursor != '',
      more: response.more,
      postId
    });
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function likeReply(postId, replyId, liked, likes) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/${replyId}/like/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'POST',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.LIKE_REPLY,
    postId,
    replyId
  });
}

export function unlikeReply(postId, replyId, liked, likes) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/${replyId}/like/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'DELETE',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.UNLIKE_REPLY,
    postId,
    replyId
  });
}

export function deleteReply(replyId, postId) {
  const url = `/ajax/event/${window.evite_event.id}/posts/${postId}/replies/${replyId}/?gid=${window.guest_id}`;
  window.$.ajax({
    type: 'DELETE',
    url
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
  store.dispatch({
    type: types.REMOVE_REPLY,
    replyId,
    postId
  });
}

export function updateTags(postId, tags) {
  const url = urls.get('ajax_edit_guest_tags', {
    event_id: window.evite_event.id,
    post_id: postId,
    gid: window.guest_id
  });
  const postData = {
    tags: JSON.stringify(tags)
  };
  window.$.ajax({
    data: postData,
    type: 'PUT',
    url
  })
  .success(function(response) {
    store.dispatch({
      type: types.UPDATE_FEED_POST,
      post: response,
      postId
    });
    window.dataLayer.push({
      'event': 'edited tags'
    });
  });
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/actions.es6